module.exports = __webpack_public_path__ + "static/media/me-about.5f4f799a.jpg";